import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appRecordCardGenericRight]',
})
export class RecordCardGenericRightDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
